<div class="ttmodal cdk-overlay-pane"  id="schematicmasterWindow" appMovable >
  
  </div>

  <div class="ttmodal__body"  style="overflow: auto;">
    <div id="schematicWindowHeader_" class="ttmodal__header" >
      <span class="ttmodal__title" style="margin-top: 18px;margin-left: 25px;">Schematic and Observation Point</span>
      <div class="panel__header__button-container">
      </div>
      <div style="display: flex;flex-direction: row;justify-content: flex-start">

<!-- edit observation point details-->

<div class="ttmodal" id="observationWindow" >
   
    </div>
    <div class="ttmodal__body" style="overflow: auto;">
      <div id="observationWindowHeader" class="ttmodal__header">
        <span class="ttmodal__title" style="margin-left: 40px;">Edit Observation Point</span>
        <div class="panel__header__button-container">
    
        </div>
      <div style="width: 620px; height: 550px;margin-left: 30px;">
        <div style="display: flex; flex-direction: row;">
          <span style="align-self: center;min-width: 102px;">Name</span>
  
          <mat-form-field style="    width: 56%">
            <input matInput placeholder="Observation Name" type="text"
                [(ngModel)]="Compname" ngDefaultControl required  (change)="updatedProperty(null, 'CompName')">
        </mat-form-field>
        </div>
  <!-- Uncomment this code for TT-9461 -->
        <div style="display: flex; flex-direction: row;">
          <span style="align-self: center;min-width: 102px;" >Component</span>
          <mat-form-field style="width: 56%;">
          <mat-select placeholder="Select Component" style="width: 345px" [(ngModel)]="componentId" ngDefaultControl required (selectionChange)="onComponentChange($event)">
            <mat-option value="" disabled selected>Select Component</mat-option>
            <mat-option *ngFor="let component of componentList" [value]="component.ComponentId">{{component.Name}}</mat-option>
          </mat-select>
          </mat-form-field>
        </div>
  
  
        <!-- <div style="display: flex; flex-direction: row; margin-top: 2%;margin-bottom: 2%;">
         
  
          <span style="align-self: center;min-width: 102px;">Date</span>
          <mat-form-field class="header-form-full-width">
           
            <input matInput [matDatepicker]="endDatePicker" placeholder="Created Date" [(ngModel)]="eventDate"  [min]="minDate" [max]="maxDate">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div> -->
       
        <!-- <div style="display: flex; flex-direction: row; margin-top: 2%;margin-bottom: 2%;">
          <span style="align-self: center;min-width: 102px;">Types</span>
          <mat-radio-group name="type" [(ngModel)]="TypeID" style="margin-left: 32px;">
            <mat-radio-button [value]="1" title="Thickness Measurement" #normal (change)="changeType($event)">Normal
            </mat-radio-button>
            <mat-radio-button [value]="2" title="Crack Measurement" #crack (change)="changeType($event)">Crack
            </mat-radio-button>
          </mat-radio-group>
        </div> -->
        <ng-container *ngFor="let cp of FilteredschematicList_.ObservationPoints">
            <ng-container *ngIf="cp.ObservationType == 'Crack' && cp.SelectedObs==true">

        <div style="display: flex; flex-direction: row;" >
          <span  style="align-self: center;min-width: 102px;">Click pencil, then specific Point in image to Create Crack Start Point then confirm with tick box</span>
          <a (click)="ClearCurrentStartXY()"><i class="material-icons square-button__icon" style="cursor: pointer;">edit</i></a>
          <mat-form-field style="width: 20%;">
            <input matInput type="text"[(ngModel)]="startXY"  #noOfReading_="ngModel" [disabled]="true">
          </mat-form-field>
          <a  *ngIf="isStartEdit==false"><i class="material-icons square-button__icon"  title="Confirm Starting Point" style="cursor: pointer;">check_box</i></a>
          <a (click)="ConfirmStartXY()" *ngIf="isStartEdit==true"><i class="material-icons square-button__icon"  title="Confirm Starting Point" style="cursor: pointer;">check_box_outline_blank</i></a>
        </div>
  
        <div style="display: flex; flex-direction: row;"  >
          <span  style="align-self: center;min-width: 102px;">Click pencil, then specific Point in image to Create Crack End Point then confirm with tick box</span>
     
          <a (click)="ClearCurrentEndXY()"><i class="material-icons square-button__icon">edit</i></a>
          <mat-form-field style="width: 20%;">
            <input matInput type="text"[(ngModel)]="endXY"  #noOfReading_="ngModel" [disabled]="true">
          </mat-form-field>
          <a *ngIf="isEndEdit==false"><i class="material-icons square-button__icon"  title="Confirm Ending Point">check_box</i></a>
          <a *ngIf="isEndEdit==true"(click)="ConfirmEndXY()"><i class="material-icons square-button__icon"  title="Confirm Starting Point" style="cursor: pointer;">check_box_outline_blank</i></a>
        </div>
  </ng-container>

  
  </ng-container>

  <table>
    <thead>
      <tr>
        <th>Description</th>
        <th>X coord</th>
        <th>Y coord</th>
        <th>End X coord</th>
        <th>End Y coord</th>
      </tr>
    </thead>
    
    <tbody>
      <tr *ngFor="let cp of FilteredschematicList_2.ObservationPoints; let i = index" [class.SelectedObs]="cp.SelectedObs" > 
        <ng-container *ngIf="cp.Id>0">
          <td>{{cp.Name}}</td>
          <td>
            <input style="width: 45px;" [(ngModel)]="cp.PositionX" (change)="updatedProperty(cp, 'PositionX')" />
          </td>
          <td>
            <input style="width: 45px;" [(ngModel)]="cp.PositionY" (change)="updatedProperty(cp, 'PositionY')"/>
          </td>
          <td *ngIf="cp.EndPositionX !== null">
            <input style="width: 45px;" [(ngModel)]="cp.EndPositionX"  (change)="updatedProperty(cp, 'PositionX')"  />
          </td>
          <td *ngIf="cp.EndPositionY !== null">
            <input style="width: 45px;" [(ngModel)]="cp.EndPositionY"   (change)="updatedProperty(cp, 'PositionX')"/>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
        <!-- <div style="display: flex; flex-direction: row;"*ngIf="TypeID==1">
          <span *ngIf="TypeID==1"  style="align-self: center;min-width: 118px;">Use Range</span>
          <mat-checkbox  *ngIf="TypeID==1" id="fecrNormal" [(ngModel)]="isFECRNormal" [checked]="isFECRNormal"
            style="margin-left: 16px!important; margin-right: 16px!important;" color="primary">
          </mat-checkbox>
        </div>
        <div style="display: flex; flex-direction: row;"  *ngIf="TypeID==2">
          <span  *ngIf="TypeID==2"  style="align-self: center;min-width: 102px;">Crack-Ignore Limits</span>
          <mat-checkbox *ngIf="TypeID==2" id="fecrCrack_" [(ngModel)]="isFECRCrack" [checked]="isFECRCrack"
            style="margin-left: 16px!important; margin-right: 16px!important;" color="primary">
          </mat-checkbox>
        </div> -->
       
  
        <!-- <div style="display: flex; flex-direction: row;" *ngIf="!isFECRCrack ">
          <span   style="align-self: center;min-width: 102px;">Limit-New</span>
          <mat-form-field style="width: 20%;">
            <input matInput type="number" min="0" [(ngModel)]="limitNew" (focusout)="checkPositive()" #limitNew_="ngModel"
              (keypress)="ValidateNumberInputs($event)" [disabled]="isDisabled">
              <span matSuffix>(mm)</span>
          </mat-form-field>
          
        </div> -->
  
        <!-- <div style="display: flex; flex-direction: row;" *ngIf="!isFECRCrack && !isFECRNormal">
          <span  style="align-self: center;min-width: 102px;">Limit-Worn</span>
          <mat-form-field style="width: 20%;">
            <input matInput type="number" min="0" [(ngModel)]="limitWorn" (focusout)="checkPositive()"
              #limitWorn_="ngModel" (keypress)="ValidateNumberInputs($event)" [disabled]="isDisabled">
              <span matSuffix>(mm)</span>
          </mat-form-field>
       
  
        
  
        </div> -->
<!--   
        <div style="display: flex; flex-direction: row;" *ngIf="!isFECRCrack && isFECRNormal">
          <span  style="align-self: center;min-width: 102px;">Limit-Range</span>
          <mat-form-field style="width: 20%;">
            <input matInput type="number" min="0" [(ngModel)]="limitRange" (focusout)="checkPositive()"
              #limitRange_="ngModel" [disabled]="isDisabled">
              <span matSuffix>(mm)</span>
          </mat-form-field>
         
        </div> -->
  
        <!-- <div style="display: flex; flex-direction: row;" *ngIf="isFECRCrack">
          <span  style="align-self: center;min-width: 102px;">Measurement</span>
          <mat-form-field   style="width: 20%;">
            <input matInput type="number" min="0" [(ngModel)]="measurement" (focusout)="checkPositive()"
              #measurement_="ngModel" (keypress)="ValidateNumberInputs($event)">
              <span matSuffix>(mm)</span>
          </mat-form-field>
         
        </div> -->
        
  
        <!-- <div class="ttmodal__footer"> -->
          <!-- <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a> -->
          <!-- <a class="button button--primary" (click)="editComponentForObservation()"><span class="button__text">Save Changes</span></a> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
          <!-- <add-observation-point *ngIf="showAddObservation" [(cusID)]="CustomerId" [(implementID)]="ImplementId" [(showOPWindow)]="showAddObservation" (closeObservationWindow)="onCloseObservationWindow($event)"
              [(positionX)]="eventX" [(positionY)]="eventY" [(schematicID)]="schematic" style="width:600px;" [class.nodisplay]="!showAddObservation"> </add-observation-point> -->

          <div class="ttmodal" id="schematicWindow">
              <div id="schematicWindowHeader" class="ttmodal__header">
                  <span class="ttmodal__title">{{title}}</span>
                  <div class="panel__header__button-container" id="closeButton">
                   
                      <a class="button waves-effect" (click)="onCloseClick()">
                          <i class="material-icons button__icon">cancel</i>
                          <span class="button__text">Close</span> 
                      </a>
                  </div>
              </div>

              <!-- <div class="ttmodal__body" style="width: 620px; overflow: auto; "> -->
                <!-- TT-9461 3RD POINT  -->
                <div class="ttmodal__body" style="height: 600px;">
                  <div *ngIf="schematic.Data != null" style="width: auto; height: auto; position: relative; margin-left: 2px;">
                      <img [src]="getImage(schematic.Data)"  style="width:100%; height: 100%;" 
                          (click)="openObservationPointModal($event);ConfirmStartXY();ConfirmEndXY() " >
                      <ng-container *ngIf="FilteredschematicList_.ObservationPoints != null">
                          <ng-container *ngFor="let cp of FilteredschematicList_.ObservationPoints">
                              <i class="material-icons button__icon component-dot" *ngIf="cp.ObservationType != 'Crack'"
                                 
                                  [class.default]="cp.SelectedObs==true" 
                                  [class.no-eval]="cp.SelectedObs==false &&  cp.Id>0"

                                  [class.orange-eval]="cp.Id==-1"
                                 
                                  [class.component-dot2]="mouseoverOPId == cp.Id" (mouseover)="onMouseOverOP(cp.Id)"
                                  (mouseout)="onMouseOutOP(cp.Id)" matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}} X,Y Coords - {{cp.PositionX}},{{ cp.PositionY}}"
                                  [style]="getPosition(cp.PositionX, cp.PositionY)" >lens</i>

                            <!-- <ng-container *ngIf="cp.ObservationType == 'Crack'">
                              <i class="material-icons button__icon component-dot2"  style="line-height: 0; " *ngIf="cp.EndPositionX!=null"
                                  matTooltip="{{cp.Name}} X,Y Coords - {{cp.EndPositionX}},{{ cp.EndPositionY}}"  (click)="SelectObPoint(cp)"
                                  [class.default]="cp.SelectedObs==true" 
                                  [class.no-eval]="cp.SelectedObs==false && cp.Id>0"   
                                  [class.orange-eval]="cp.Id==-1"
                                  [style]="getPosition(cp.EndPositionX, cp.EndPositionY)"> lens</i>
                            </ng-container> -->

                            <div *ngIf="cp.EndPositionX!=null && cp.EndPositionX !=0 " 
                            [class.component-dot2]="mouseoverOPId == cp.Id" 
                            [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                            (mouseenter)="onMouseOverOP(cp.Id)" 
                            (mouseleave)="onMouseOutOP(0)"
                            matTooltip="{{cp.Name}} Last Inspection - {{cp.LastInspectionDate}} - Current Length {{cp.CurrentLength}} - Crack Status {{cp.CrackStatus}}
                                    {{ cp.CrackStatusId === 1 ? '' : ' - (' + cp.WornPct + '% Worn)' }}"
                            [style]="getLine(cp.PositionX, cp.PositionY,cp.EndPositionX, cp.EndPositionY,cp.IsCrackFixed)"></div>
                          </ng-container>
                          <!-- <ng-container *ngIf="TempObservationPoints.Id ==-1">
                                  <i class="material-icons button__icon  " [class.default]="getEval(cp.WornPct, cp.InspectionDate) == 'magenta'"></i>
                              </ng-container> -->
                      </ng-container>
                  </div>
              </div>
          </div>
      </div>


  </div>
</div>